import { queryOptions } from "@tanstack/react-query";
import { api } from "./client";
import { payload } from "./envelope";
import type { components } from "./schema";

export type Professional = components["schemas"]["Professional"];
export type ProfessionalRequest = components["schemas"]["ProfessionalRequest"];
export type UpdateProfessionalRequest =
  components["schemas"]["UpdateProfessionalRequest"];

/**
 * Equipe do estabelecimento (lista não paginada). `nickname` é o que aparece
 * nas listas interativas do WhatsApp (teto de 24 chars da Meta); `specialty`
 * e `bio` vêm como string vazia quando não preenchidos, nunca `null`.
 */
export function professionalsQuery(establishmentId: string) {
  return queryOptions({
    queryKey: ["establishment", establishmentId, "professionals"] as const,
    queryFn: () =>
      payload(
        api.GET("/establishments/{id}/professionals", {
          params: { path: { id: establishmentId } },
        }),
      ),
  });
}

export function createProfessional(
  establishmentId: string,
  body: ProfessionalRequest,
): Promise<Professional> {
  return payload(
    api.POST("/establishments/{id}/professionals", {
      params: { path: { id: establishmentId } },
      body,
    }),
  );
}

/**
 * Update parcial: campo ausente preserva; string vazia em `specialty`/`bio`
 * apaga o campo — é o que a tela quer dizer quando o dono limpa o input.
 */
export function updateProfessional(
  id: string,
  body: UpdateProfessionalRequest,
): Promise<Professional> {
  return payload(api.PUT("/professionals/{id}", { params: { path: { id } }, body }));
}

/**
 * `active=false` some das opções do bot e do cálculo de disponibilidade sem
 * apagar nada — é o caminho de quem saiu da equipe ou entrou em licença
 * longa. Os agendamentos passados, o vínculo com serviços e o histórico
 * ficam intactos, e `activate` desfaz a qualquer momento. Para afastamento
 * com data marcada, o certo é uma ausência, não isto.
 */
export function deactivateProfessional(id: string): Promise<Professional> {
  return payload(
    api.POST("/professionals/{id}/deactivate", { params: { path: { id } } }),
  );
}

export function activateProfessional(id: string): Promise<Professional> {
  return payload(
    api.POST("/professionals/{id}/activate", { params: { path: { id } } }),
  );
}
